import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["exact", "strict"];
import PropTypes from 'prop-types';
import UITab from 'UIComponents/nav/UITab';
import { Tab } from 'foundations-components/transitional/components/Tabs';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { cloneDefaultProps, clonePropTypes, isLegacyComponent } from './internal/utils';

// TODO: remove Omit after migrating all icon prop usages from string to component
// TODO: refactor to use Tab after deprecating UIComponents part
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIRouterTab(props) {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  // TODO remove this logic after deprecating style & className props
  // + after migrating icon prop from string to component
  const TabComponent = isLegacyComponent(props, ['style', 'className', 'icon']) ? UITab : Tab;
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, rest, {
    component: TabComponent
  }));
}
const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
  sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);
const _clonePropTypes = clonePropTypes(UITab),
  sanitizedTabPropTypes = _objectWithoutPropertiesLoose(_clonePropTypes, ["tabId"]);

// TODO remove after deprecating UIComponents part
UIRouterTab.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, sanitizedTabPropTypes, {
  children: PropTypes.node,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  // TODO remove after UIComponents is no longer createReactClass
  tooltipProps: PropTypes.object,
  onClick: PropTypes.func,
  // TODO override to get around UITabs childrenPropTypeValidator
  tabId: PropTypes.string
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIRouterTab.defaultProps = Object.assign({}, cloneDefaultProps(UITab), {
  exact: false,
  strict: false
});